<template>
  <div>
    <loading
      :active.sync="loading.app"
      :can-cancel="false"
      :is-full-page="true"
      :color="'#0B8BCC'"
      :loader="'dots'"
      :opacity="0.7"
      :lock-scroll="true"
    ></loading>
    <Toast
      :show.sync="toast.show"
      :message="toast.message"
      :tipe="toast.tipe"
      @close="toast.show = false"
      :position="toast.position"
      :icon="toast.icon"
    ></Toast>
    <!-- App Header -->
    <div class="appHeader bg-primary text-light shadow-header-footer">
      <div class="left">
        <a href="Javascript:;" class="headerButton" @click="$router.go(-1)">
          <!-- <router-link class="headerButton" :to="{ name: 'donasi' }"> -->
          <ion-icon name="chevron-back-outline"></ion-icon>
          <!-- </router-link> -->
        </a>
      </div>
      <div class="pageTitle">Tambah Donasi</div>
    </div>
    <!-- * App Header -->
    <!-- App Capsule -->
    <div id="appCapsule" v-if="loading.app == false">
      <div class="section" style="margin-top:15px;">
        <h3 style="margin-bottom: 5px;">Masukkan Nominal Donasi</h3>
        <p style="font-size: 12px;line-height: 150%;margin-bottom: 0px;">
          Nominal donasi yang Kamu tambahkan Minimal Rp 500. Ayo donasi
          sekarang!
        </p>
      </div>
      <div class="section inset">
        <div class="form-group boxed">
          <div class="input-wrapper">
            <input
              type="tel"
              class="form-control"
              v-model="donasi_data.nominal"
              style="font-size:13px;"
              placeholder="Nominal Donasi"
              @input="inputNominal"
            />
          </div>
        </div>
        <div class="form-group basic pb-0 pt-0">
          <button
            v-for="item in listNominal"
            :key="item"
            class="btn btn-outline-primary btn-sm mr-1 mb-1"
            style="border-radius:50px;"
            @click="inputNominal(item)"
          >
            Rp {{ item | rupiah }}
          </button>
        </div>
        <div class="form-group basic">
          <button
            class="btn btn-primary btn-block btn-lg"
            @click="showConfirm()"
            :disabled="donasi_data.nominal.replace(/[^,\d]/g, '') < 500"
          >
            Tambah Sekarang
          </button>
        </div>
      </div>
    </div>

    <action-sheet
      ref="modalConfirmation"
      :title="'Konfirmasi Donasi'"
      :header="true"
      :inset="false"
      :content-height="true"
    >
      <div class="text-center" style="border-bottom:1px dashed #dee2e6;">
        <h4>Kamu akan melakukan donasi sebesar</h4>
        <h3>Rp {{ donasi_data.nominal }}</h3>
        <p style="font-size:13px;line-height:18px;">
          Donasi yang kamu berikan akan dikumpulkan dan disalurkan di banyak
          bidang sosial seperti Pendidikan, Kesehatan, dan Kemanusiaan bagi
          saudara-saudara kita yang membutuhkan
        </p>
        <p style="font-size:13px;line-height:18px;">Lakukan Donasi Sekarang?</p>
      </div>
      <!-- <div class="form-group boxed" v-if="customer.pin_trx == 'ENABLED'">
        <label class="label text-center">Masukkan PIN</label>
        <input
          type="number"
          pattern="[0-9]*"
          inputmode="numeric"
          class="form-control form-control-lg text-center p-0 input-password"
          style="letter-spacing: 0.7em"
          maxlength="6"
          v-model="donasi_data.pin"
          oninput="this.value = this.value.replace(/[^0-9]/g, '')"
        />
      </div> -->
      <div class="form-group basic pb-0">
        <div class="row">
          <div class="col-6">
            <button
              class="btn btn-outline-primary btn-block btn-lg"
              style="height:40px;border-width:1px;"
              @click="hideConfirm()"
            >
              Batal
            </button>
          </div>
          <div class="col-6">
            <ButtonLoader
              :loading="loadingButton"
              :styled="'btn btn-primary btn-block btn-lg'"
              style="height:40px;"
              @click.native="verifyWithoutPin()"
              :disabled="
                customer.balance < donasi_data.nominal.replace(/[^,\d]/g, '')
              "
              v-if="customer.pin_trx == 'DISABLED'"
              >Ya, Donasi</ButtonLoader
            >
            <button
              class="btn btn-primary btn-block btn-lg"
              style="height:40px;border-width:1px;"
              :disabled="
                customer.balance < donasi_data.nominal.replace(/[^,\d]/g, '')
              "
              @click="verifyWithPin()"
              v-else
            >
              Ya, Donasi
            </button>
          </div>
        </div>
      </div>
    </action-sheet>

    <action-sheet ref="status" :title="'#DonasiJadiBerkah'" :inset="true">
      <div class="iconbox text-success">
        <ion-icon name="checkmark-circle"></ion-icon>
      </div>
      <div class="text-center p-2">
        <h3>Donasi Berhasil</h3>
        <p style="font-size:13px;line-height:18px;">
          Terima kasih atas kebaikannya, semoga usaha dan rezeki kamu selalu
          dilancarkan. Amin!
        </p>
      </div>
      <div class="form-group basic">
        <button
          class="btn btn-outline-primary btn-block btn-lg"
          @click="hideStatus"
        >
          Tutup
        </button>
      </div>
    </action-sheet>
  </div>
</template>
<script>
import { mapState } from "vuex";
import $axios from "../../api.js";
export default {
  props: ["toast_reference"],
  data() {
    return {
      loadingButton: false,
      listNominal: [500, 1000, 5000, 10000, 25000, 50000, 75000, 100000],
      donasi_data: {
        nominal: "",
        // pin: "",
      },
    };
  },
  created() {
    setTimeout(() => this.$store.commit("SET_LOADING", { app: false }), 500);
  },
  computed: {
    ...mapState(["customer", "loading", "toast"]),
  },
  methods: {
    showConfirm() {
      if (this.donasi_data.nominal.replace(/[^,\d]/g, "") >= 500) {
        if (
          this.customer.balance >=
          this.donasi_data.nominal.replace(/[^,\d]/g, "")
        ) {
          let element = this.$refs.modalConfirmation.$el;
          window.$(element).modal("show");
        } else {
          this.$store.commit("SET_TOAST", {
            show: true,
            message: "Saldo tidak cukup",
            tipe: "default",
            icon: "warning",
          });
        }
      } else {
        this.$store.commit("SET_TOAST", {
          show: true,
          message: "Minimal donasi Rp 500",
          tipe: "default",
          icon: "warning",
        });
      }
    },
    hideConfirm() {
      this.donasi_data.pin = "";
      let element = this.$refs.modalConfirmation.$el;
      window.$(element).modal("hide");
    },
    showStatus() {
      let element = this.$refs.status.$el;
      window.$(element).modal("show");
    },
    hideStatus() {
      let element = this.$refs.status.$el;
      window.$(element).modal("hide");
    },
    inputNominal(nominal) {
      this.$store.commit("RESET_TOAST");
      if (this.donasi_data.nominal == "") {
        this.donasi_data.nominal = "0";
      }
      if (nominal == undefined) {
        const nominal_request = parseInt(this.donasi_data.nominal);
        this.donasi_data.nominal = this.$options.filters.inputRupiah(
          nominal_request.toString()
        );
      } else {
        const nominal_request =
          parseInt(this.donasi_data.nominal.replace(/[^,\d]/g, "")) + nominal;
        this.donasi_data.nominal = this.$options.filters.inputRupiah(
          nominal_request.toString()
        );
      }
    },
    verifyWithoutPin() {
      this.loadingButton = true;
      $axios
        .post("/donasi/add", this.donasi_data)
        .then(() => {
          this.donasi_data.nominal = "";
          this.donasi_data.pin = "";
          this.hideConfirm("hide");
          this.loadingButton = false;
          this.showStatus();
        })
        .catch((error) => {
          this.$store.commit("SET_TOAST", {
            show: true,
            message: error.response.data.message,
            tipe: "default",
            icon: "danger",
          });
          this.hideConfirm("hide");
          this.loadingButton = false;
        });
    },
    verifyWithPin() {
      this.hideConfirm();
      this.$router.push({
        name: "auth.pin.verify",
        params: {
          data_reference: this.donasi_data,
          url_reference: "/donasi/add",
          previous_page_reference: "donasi.add",
          next_page_reference: "donasi.add",
        },
      });
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.toast_reference != undefined) {
        if (
          this.toast_reference.show &&
          this.toast_reference.icon == "success"
        ) {
          this.showStatus();
        } else {
          this.$store.commit("SET_TOAST", this.toast_reference);
        }
        //   this.$store.commit("SET_TOAST", this.toast_reference);
      }
    }, 500);
  },
  destroyed() {
    this.$store.commit("RESET_LOADING");
    this.$store.commit("RESET_TOAST");
  },
  filters: {
    inputRupiah: function(value) {
      var number_string = value.replace(/[^,\d]/g, "").toString(),
        split = number_string.split(","),
        sisa = split[0].length % 3,
        rupiah = split[0].substr(0, sisa),
        ribuan = split[0].substr(sisa).match(/\d{3}/gi);

      if (ribuan) {
        var separator = sisa ? "." : "";
        rupiah += separator + ribuan.join(".");
      }

      rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
      return rupiah;
    },
  },
};
</script>
